import React from 'react'
import { animateScroll as scroll } from 'react-scroll'
import 
{ 
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SiderbarMenu,
    SidebarLink,
    SideBtnWrap,
    SidebarRoute
} from './SidebarElements'

const Sidebar = ({ isOpen, toggle }) => {

    const toggleHome = () => {
        toggle()
        scroll.scrollToTop()
    }

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
            <CloseIcon />
        </Icon>

        <SidebarWrapper>
            <SiderbarMenu>
                <SidebarLink to="/" smooth={true} duration={500} spy={true} exact='true' offset={-80} onClick={toggleHome}>Home</SidebarLink>
                <SidebarLink to="about" smooth={true} duration={500} spy={true} exact='true' offset={-80} onClick={toggle}>O mně</SidebarLink>
                <SidebarLink to="stats" smooth={true} duration={500} spy={true} exact='true' offset={-80} onClick={toggle}>Statistiky</SidebarLink>
                <SidebarLink to="games" smooth={true} duration={500} spy={true} exact='true' offset={-80} onClick={toggle}>Dohrané hry</SidebarLink>
                <SidebarLink to="upcoming_games" smooth={true} duration={500} spy={true} exact='true' offset={-80} onClick={toggle}>Nadcházející hry</SidebarLink>
            </SiderbarMenu>
        </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar